import * as React from 'react';
import topProductsServiceInstance from '../../services/products/TopProductsService';
import listService from 'src/services/lists/ListsService';
import './TopProductCardsCarousel.scss';
import Button from '../common/Button';
import ProductModel from '../../model/product.model';
import ProductCard from '../ProductCard/ProductCard';
import CarouselContainer from '../common/CarouselContainer';
import { goToProducts, ifLoggedIn, goToPartDetail } from 'src/utils/navigation';
import i18n from 'src/translation/i18n';
import exploreSmall from '../../assets/explore-small';
import { env } from 'src/shared/env';
import { connect } from 'react-redux';
import { analyticsActions } from 'src/analytics/store';
import { analyticsListNames } from 'src/analytics/constant';
import { LoadingIndicator } from 'react-select/src/components/indicators';
import { HalfCircleSpinner } from 'react-epic-spinners';

interface ITopProductCardsCarouselState {
  isLoading: boolean;
  isFavoriteLoading:boolean;
  selectedFavoriteItem: string,
  isLoadingstring: string;
  products: ProductModel[];
}

interface IDispatchFromProps {
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

export class TopProductCardsCarousel extends React.Component<
  any,
  ITopProductCardsCarouselState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      isFavoriteLoading: true,
      selectedFavoriteItem: '',
      products: [],
      isLoadingstring: ''
    };
  }

  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    if (this.props.fireProductClickEvent) {
      this.props.fireProductClickEvent({
        product: productClicked,
        list: analyticsListNames.PRODUCTS_ON_SALE
      });
    }
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private getProducts = () => {
    topProductsServiceInstance
      .getTopProducts()
      .then(res => {
        this.setState({
          isLoading: false,
          isFavoriteLoading: false,
          selectedFavoriteItem:'',
          products: res,
          isLoadingstring: 'success'
        });
        this.fireProductImpressionAnalytics();
      })
      .catch(error => {
        this.setState({
          isLoadingstring: 'error'
        });
      });
  };

  private handleToggleFavorite = (
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); // Start loading
      listService.deleteItem(favoriteId).then(res => { 
        this.getProducts(); 
      });
    } else {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name });  // Start loading
      listService
        .addItem('favorites', name, mfc)
        .then(res => {
          this.getProducts();
      }).catch(error => {
        console.error("Failed to add item:", error);
        this.setState({ isFavoriteLoading: false }); // End loading in case of error
      });
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  private viewAll = () => {
    goToProducts();
  };

  public componentDidMount() {
    this.getProducts();
  }

  private fireProductImpressionAnalytics = () => {
    let productsList: any[];
    if (this.props.isLoggedIn) {
      productsList = this.state.products.filter(
        product => product.discountInfo !== null
      );
    } else {
      productsList = this.state.products;
    }

    if (this.props.fireProductImpressionEvent) {
      this.props.fireProductImpressionEvent({
        products: productsList,
        list: analyticsListNames.PRODUCTS_ON_SALE
      });
    }
  };

  public render() {
    let productsList: any[];
    // if (this.props.isLoggedIn) {
    //   productsList = this.state.products.filter(
    //     product => product.discountInfo !== null
    //   );
    // } else {
    //   productsList = this.state.products;
    // }
    productsList = this.state.products;
    return (
      <div className="rp-top-products-cards-carousel">
        {productsList.length > 0 &&
        <div className="top-products-text">
          {i18n.t('common.productsOnSale')}
        </div>
        }
        {productsList.length ? (
          <>
            <div>
              {productsList.length > 1 ? (
                <Button
                  buttonClass="rp-recent-orders--button"
                  label={i18n.t('recentOrders.viewAll')}
                  action={this.viewAll}
                />
              ) : (
                <span />
              )}
            </div>
            <CarouselContainer loading={this.state.isLoading}>
              {productsList.length > 0 &&
                productsList.map((product, index) => (
                  <ProductCard
                    key={index}
                    part={product}
                    id={product.productNumber}
                    name={product.productNumber}
                    mfc={product.manufacturerCode}
                    description={product.description}
                    price={product.partnerPrice}
                    msrp={product.retailPrice}
                    image={
                      product.imageUrls !== null ? product.imageUrls[0] : ''
                    }
                    handleOnClicBuyNow={this.handleBuyNow}
                    handleToggleFavorite={this.handleToggleFavorite}
                    inStock={product.inStock}
                    isFavoriteLoading = {this.state.isFavoriteLoading}
                    selectedFavoriteItem = {this.state.selectedFavoriteItem}
                    favorite={product.favorite}
                    favoriteId={product.idFavoriteItem}
                    // deal={!!product.discountInfo}
                    deal={true}
                    state={product.state}
                    stateDescription={product.stateDescription}
                    reloadPart={this.reloadList}
                  />
                ))}
            </CarouselContainer>
          </>
        ) : this.props.isLoggedIn && this.state.isLoadingstring === 'error' ? (
          <div className="rp-no-data-container-main rp-product-no-data-container">
            <div className="rp-no-data-container">
              <div className="rp-no-data-text">
                <div className="rp-text-container-no-data">
                  <p className="rp-no-data-desc">
                    {i18n.t('common.noProductsOnSale')}
                  </p>
                </div>
              </div>
              <div className="rp-no-data-image-container">
                <img
                  className={
                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? 'rp-no-data-img rp-no-data-img-CA'
                      : 'rp-no-data-img'
                  }
                  src={exploreSmall}
                  alt=""
                />
              </div>
            </div>
          </div>
        ) : this.props.isLoggedIn && this.state.isLoadingstring === '' ? (
          <div className="rp-no-data-container-main rp-product-no-data-container">
            {/* <div className="rp-no-data-container">
              <div className="rp-no-data-text"> */}
            <div className="rp-text-container-no-data text-center">
              <HalfCircleSpinner
                color="#0b4da2"
                size={60}
                style={{
                  textAlign: 'center',
                  display: 'inline-block'
                }}
              />
              <p className="rp-no-data-desc">Loading...</p>
            </div>
            {/* </div> */}
            {/* <div className="rp-no-data-image-container">
                <img
                  className={
                    env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                      ? 'rp-no-data-img rp-no-data-img-CA'
                      : 'rp-no-data-img'
                  }
                  src={exploreSmall}
                  alt=""
                />
              </div> */}
            {/* </div> */}
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.productImpression(data)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.productClick(data))
});

export default connect(null, mapDispatchToProps)(TopProductCardsCarousel);
